import type { ReactElement } from 'react'

import type { ExpandArea } from '../../../recoil/cursor'
import { RSheetsStyle } from '../../util/RSheetsStyle'

export const ExpandCursorBox = ({
  asFixed,
  expandArea: { fixedRightWidth, height, width, x, y },
  headerHeight,
}: {
  asFixed: boolean
  expandArea: ExpandArea
  headerHeight: number
}): ReactElement => {
  const boxWidth = asFixed ? fixedRightWidth : width

  if (boxWidth === 0) {
    return <></>
  }

  return (
    <div
      id={`expand-cursor-box-as-fixed-${asFixed}`}
      style={{
        position: 'absolute',
        top: y + headerHeight,
        left: x,
        width: boxWidth,
        height,
        pointerEvents: 'none',

        border: `2px #3274E0 solid`,
        borderRadius: 4,
        backgroundColor: 'rgba(14, 101, 235, 0.1)',
        transition: 'all 0.2s cubic-bezier(.23, 1, .32, 1)',
        zIndex: asFixed ? RSheetsStyle.zIndex.cursorWhenLeftFixed : RSheetsStyle.zIndex.cursor,
      }}
    />
  )
}
